import { SubSink } from 'subsink';
import {
  Component,
  OnInit,
  AfterViewInit,
  OnChanges,
  SimpleChanges,
  OnDestroy,
} from '@angular/core';
import { LayoutService } from '../../core';
import KTLayoutQuickSearch from '../../../../../../assets/js/layout/extended/quick-search';
import KTLayoutQuickNotifications from '../../../../../../assets/js/layout/extended/quick-notifications';
import KTLayoutQuickActions from '../../../../../../assets/js/layout/extended/quick-actions';
import KTLayoutQuickCartPanel from '../../../../../../assets/js/layout/extended/quick-cart';
import KTLayoutQuickPanel from '../../../../../../assets/js/layout/extended/quick-panel';
import KTLayoutQuickUser from '../../../../../../assets/js/layout/extended/quick-user';
import KTLayoutHeaderTopbar from '../../../../../../assets/js/layout/base/header-topbar';
import { KTUtil } from '../../../../../../assets/js/components/util';
import { Router } from '@angular/router';
import { UserService } from '../../../../../core/services/user/user.service';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
})
export class TopbarComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  // tobbar extras
  latestUsername: string;
  profileImage: string;
  extraSearchDisplay: boolean;
  extrasSearchLayout: 'offcanvas' | 'dropdown';
  extrasNotificationsDisplay: boolean;
  extrasNotificationsLayout: 'offcanvas' | 'dropdown';
  extrasQuickActionsDisplay: boolean;
  extrasQuickActionsLayout: 'offcanvas' | 'dropdown';
  extrasCartDisplay: boolean;
  extrasCartLayout: 'offcanvas' | 'dropdown';
  extrasQuickPanelDisplay: boolean;
  extrasLanguagesDisplay: boolean;
  extrasUserDisplay: boolean;
  extrasUserLayout: 'offcanvas' | 'dropdown';
  showUnreadNotifications = true;

  private _subs = new SubSink();
  // tslint:disable-next-line:max-line-length
  constructor(
    private layout: LayoutService,
    public router2: Router,
    public userService: UserService
  ) {}

  ngOnInit(): void {
    // topbar extras
    this.extraSearchDisplay = this.layout.getProp('extras.search.display');
    this.extrasSearchLayout = this.layout.getProp('extras.search.layout');
    this.extrasNotificationsDisplay = this.layout.getProp('extras.notifications.display');
    this.extrasNotificationsLayout = this.layout.getProp('extras.notifications.layout');
    this.extrasQuickActionsDisplay = this.layout.getProp('extras.quickActions.display');
    this.extrasQuickActionsLayout = this.layout.getProp('extras.quickActions.layout');
    this.extrasCartDisplay = this.layout.getProp('extras.cart.display');
    this.extrasCartLayout = this.layout.getProp('extras.cart.layout');
    this.extrasLanguagesDisplay = this.layout.getProp('extras.languages.display');
    this.extrasUserDisplay = this.layout.getProp('extras.user.display');
    this.extrasUserLayout = this.layout.getProp('extras.user.layout');
    this.extrasQuickPanelDisplay = this.layout.getProp('extras.quickPanel.display');
    this.getProfileImage();
    this._listenToRoutesChange();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.getProfileImage();
  }

  ngAfterViewInit(): void {
    KTUtil.ready(() => {
      // Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
      // Add 'implements AfterViewInit' to the class.
      if (this.extraSearchDisplay && this.extrasSearchLayout === 'offcanvas') {
        KTLayoutQuickSearch.init('kt_quick_search');
      }

      if (this.extrasNotificationsDisplay && this.extrasNotificationsLayout === 'offcanvas') {
        // Init Quick Notifications Offcanvas Panel
        KTLayoutQuickNotifications.init('kt_quick_notifications');
      }

      if (this.extrasQuickActionsDisplay && this.extrasQuickActionsLayout === 'offcanvas') {
        // Init Quick Actions Offcanvas Panel
        KTLayoutQuickActions.init('kt_quick_actions');
      }

      if (this.extrasCartDisplay && this.extrasCartLayout === 'offcanvas') {
        // Init Quick Cart Panel
        KTLayoutQuickCartPanel.init('kt_quick_cart');
      }

      if (this.extrasQuickPanelDisplay) {
        // Init Quick Offcanvas Panel
        KTLayoutQuickPanel.init('kt_quick_panel');
      }

      if (this.extrasUserDisplay && this.extrasUserLayout === 'offcanvas') {
        // Init Quick User Panel
        KTLayoutQuickUser.init('kt_quick_user');
      }

      // Init Header Topbar For Mobile Mode
      KTLayoutHeaderTopbar.init('kt_header_mobile_topbar_toggle');
    });
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }

  getProfileImage(): void {
    if (!this.userService.userHasLoggedIn) {
      return;
    }
    this.userService.getUserName().then(userName => {
      if (this.latestUsername !== userName) {
        this.latestUsername = userName;
        this.userService.getUserProfileImage().then(data => {
          this.profileImage = data;
        });
      }
    });
  }

  logout(): void {
    this.userService.logout();
  }

  goToProfile(): void {
    this.router2.navigateByUrl('/profile/overview');
  }

  _listenToRoutesChange(): void {
    this.showUnreadNotifications = !this.router2.url?.includes('/notifications/list');
    this._subs.sink = this.router2.events.subscribe((route: any) => {
      this.showUnreadNotifications = !route.url?.includes('/notifications/list');
    });
  }
}
